import axios from 'axios';
import {
  KEY_ACCESS_TOKEN,
  configUrl,
  examModuleURL,
  KEY_ACCESS_TOKENS,
  ACCESS_TOKEN,
} from './constants';
import UrlEndPoints from './urlEndPoint.json';
import moment from 'moment';

let appConfig;

export let axiosInstance;
export let etlAxiosInstance;

const getInsConfig = (config = appConfig) => {
  return config;
};

export const getAxiosInstance = (data) => {
  if (axiosInstance) {
    return axiosInstance;
  }
  appConfig = data.config;
  console.log('appConfig ', appConfig);
  axiosInstance = axios.create({
    baseURL: `${appConfig.apiBaseUrl}`,
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      var config = {
        method: 'get',
        baseURL: `${appConfig.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        if (error.response != undefined) {
          error.response.config.headers[
            'Authorization'
          ] = `Bearer ${response.data.access_token}`;
          return axios(error.response.config);
        }
      });
    }
  );
  return axiosInstance;
};

//etl
export const getETLAxiosInstance = async (data) => {
  appConfig = await getInsConfig(data[0].config);
  etlAxiosInstance = axios.create({
    baseURL: `${appConfig.etlBaseUrl}`,
    timeout: 15000,
  });

  etlAxiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  });

  //Response interceptor for API calls
  etlAxiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      var config = {
        method: 'get',
        // baseURL: `${appConfig.apiBaseUrl}/token?grant_type=client_credentials`,
        // headers: {
        //   Authorization: `Basic ${appConfig.tokenHeader}`,
        // },
        baseURL: `${appConfig.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        if (error.response != undefined) {
          error.response.config.headers[
            'Authorization'
          ] = `Bearer ${response.data.access_token}`;
          return axios(error.response.config);
        }
      });
    }
  );
};

export const sendMail = async (data) => {
  const path = `${UrlEndPoints.email}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const sendSMS = async (data) => {
  const path = `${UrlEndPoints.sms}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const getcoursebyprogramplan = async (id) => {
  const path = `${UrlEndPoints.getcoursebyprogramplan}`;
  const res = await axiosInstance.get(`${appConfig.apiBaseUrl}/${path}/${id}`);
  return res && res.data ? res.data : null;
};

export const getProgramPlan = async (id) => {
  const path = `${UrlEndPoints.programPlan}`;
  const res = await axiosInstance.get(`${appConfig.apiBaseUrl}/${path}/${id}`);
  return res && res.data ? res.data : null;
};

export const postNotification = async (data) => {
  const path = `${UrlEndPoints.notify}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const getAcademicProgram = async (id) => {
  const path = `${UrlEndPoints.academicProgram}`;
  const res = await axiosInstance.get(`${appConfig.apiBaseUrl}/${path}/${id}`);
  return res && res.data ? res.data : null;
};

export const getInstituteDetails = async (id) => {
  const path = `${UrlEndPoints.instituteAccount}`;
  const res = await axiosInstance.get(
    `${appConfig.instituteUrl}/${path}/${id}`
  );
  return res && res.data ? res.data : null;
};

//----------------------------------Time Table--------------------------------------------

//get all institutes
// Please refer getInstituteByTypeAndInstitute

//get master timetable
export const getMasterTimetable = async (date, id) => {
  if (date instanceof Date) {
    date = moment(date).format('YYYY-MM-DD');
  }
  const path = `${UrlEndPoints.masterTimetable}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${date}/${id}`
  );
  return res && res.data ? res.data : null;
};

//get all time blocks
export const getAllTimeBlocks = async (instituteId) => {
  const path = `${UrlEndPoints.allTimeBlocks}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${instituteId}`
  );
  return res && res.data ? res.data : null;
};

//Delete schedule (subject/class)
export const deleteSchedule = async (scheduleId) => {
  const path = `${UrlEndPoints.schedule}`;
  const res = await axiosInstance.delete(
    `${appConfig.adminUrl}/${path}/${scheduleId}`
  );
  return res && res.data ? res.data : null;
};

// create schedule
export const createSchedule = async (data) => {
  const path = `${UrlEndPoints.schedule}`;
  const res = await axiosInstance.post(`${appConfig.adminUrl}/${path}`, data);
  return res && res.data ? res.data : null;
};

//get all course offerings
export const getAllCourses = async (date, id) => {
  if (date instanceof Date) {
    date = moment(date).format('YYYY-MM-DD');
  }
  const path = `${UrlEndPoints.courseOffering}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${date}/${id}`
  );
  return res && res.data ? res.data : null;
};

//-------------------------------------------------------------------------------------------
export const getConfig = async () => {
  const path = 'sp-jain-stg-adminportal.ken42.com';
  const res = await axios.get(`${configUrl}/${path}`);
  // console.log(res?.data, 'res....');
  return res && res.data ? res.data : null;
};

export const getJobDetails = async (instituteId) => {
  const path = `${UrlEndPoints.jobDetails}`;
  const res = await etlAxiosInstance.get(
    `${appConfig.etlBaseUrl}${path}/${instituteId}`
  );
  return res && res.data ? res.data : null;
};

export const getSubJobDetails = async (instituteId, jobId) => {
  const path = `${UrlEndPoints.jobDetails}`;
  const res = await etlAxiosInstance.get(
    `${appConfig.etlBaseUrl}${path}/${instituteId}/${jobId}`
  );
  console.log(res?.data, 'subJobDetails....');
  return res && res.data ? res.data : null;
};

export const createJob = async (upload) => {
  const path = `${UrlEndPoints.jobDetails}`;
  const res = await etlAxiosInstance.post(
    `${appConfig.etlBaseUrl}${path}`,
    upload.data,
    {
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
    }
  );
  console.log(res, 'response of create job');
  return res && res.data ? res.data : null;
};

export const getErrorLog = async (error, jobId) => {
  const path = `${UrlEndPoints.errorLog}`;
  const res = await etlAxiosInstance.get(
    `${appConfig.etlBaseUrl}/${path}/${jobId}`
  );
  console.log(res?.data, 'subJobDetails....');
  return res && res.data ? res.data : null;
};

export const postStorageDb = async (data) => {
  const path = `${UrlEndPoints.create}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const createEvents = async (payload) => {
  const path = `${UrlEndPoints.event}`;
  const res = await axiosInstance.post(
    `${appConfig.adminUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};
export const getAccountData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/data/v54.0/sobjects/Account`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getEvents = async (payload) => {
  const path = `${UrlEndPoints.events}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const updateEvent = async (payload) => {
  const path = `${UrlEndPoints.event}`;
  const res = await axiosInstance.put(`${appConfig.adminUrl}/${path}`, payload);
  return res && res.data ? res.data : null;
};

export const deleteEvent = async (eventId) => {
  const path = `${UrlEndPoints.event}`;
  const res = await axiosInstance.delete(
    `${appConfig.adminUrl}/${path}/${eventId}`
  );
  return res && res.data ? res.data : null;
};

export const getSmsTemplates = async () => {
  const path = `${UrlEndPoints.smsTemplates}`;
  const res = await axiosInstance.get(`${appConfig.adminUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const sendBulkSMS = async (payload) => {
  const path = `${UrlEndPoints.sms}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const sendBulkMail = async (payload) => {
  const path = `${UrlEndPoints.email}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const gradeWiseSms = async (payload) => {
  const path = `${UrlEndPoints.gradeWiseSms}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const gradeWiseMail = async (payload) => {
  const path = `${UrlEndPoints.gradeWiseEmail}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const getInstituteByTypeAndInstitute = async (type, value) => {
  const path = `${UrlEndPoints.institute}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${type}/${value}`
  );
  return res && res.data ? res.data : null;
};

// export const getDeprtmentists = async (instituteId) => {
//   const path = `${UrlEndPoints.getDeptURL}`;
//   const res = await axiosInstance.get(`${appConfig.adminUrl}/${path}/${instituteId}`);
//   return res && res.data ? res.data : null;
// };

export const postSubjects = async (data) => {
  const path = `${UrlEndPoints.schedule}`;
  const res = await axiosInstance.put(`${appConfig.adminUrl}/${path}`, data);
  return res && res.data ? res.data : null;
};

export const getEventRegisterList = async (eventId, contactId) => {
  const path = `${UrlEndPoints.eventDetails}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${eventId}`
  );
  return res && res.data ? res.data : null;
};

export const sendDynamicMail = async (payload) => {
  const path = `${UrlEndPoints.dynamicEmail}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const imageUpload = async (payload) => {
  const path = `${UrlEndPoints.imageUpload}`;
  const res = await etlAxiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload,
    {
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
    }
  );
  return res && res.data ? res.data : null;
};

export const getInstitutes = async () => {
  const path = `${UrlEndPoints.institutes}/0`;
  const res = await axiosInstance.get(`${appConfig.adminUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getFilterContacts = async (educationInstitution) => {
  const path = `${UrlEndPoints.filterContacts}&educationInstitution=${educationInstitution}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getRoleTypes = async () => {
  const path = `${UrlEndPoints.roleTypes}`;
  const res = await axiosInstance.get(`${appConfig.adminUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getAcademicProgramByInstituteId = async (instituteId) => {
  const path = `${UrlEndPoints.academicProgramByInstituteId}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${instituteId}`
  );
  return res && res.data ? res.data : null;
};

export const getProgramPlanByAcademicProgramId = async (academicId) => {
  const path = `${UrlEndPoints.programPlanByAcademicProgramId}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${academicId}`
  );
  return res && res.data ? res.data : null;
};

export const getClassSectionByProgramPlanId = async (programId) => {
  const path = `${UrlEndPoints.classSectionByProgramPlanId}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${programId}`
  );
  return res && res.data ? res.data : null;
};

export const postAssignRole = async (data) => {
  const path = `${UrlEndPoints.assignRole}`;
  const res = await axiosInstance.post(`${appConfig.adminUrl}/${path}`, data);
  return res && res.data ? res.data : null;
};

export const getBatchFilter = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/CurrentPageFilter`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getCurrentBatch = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/CurrentPageFilter/?filter=${filterData.filter}&termStatus=${filterData.status}&campus=${filterData.campus}&intake=${filterData.intake}&program=${filterData.program}&batch=${filterData.batch}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getAcademicFilter = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/AcademicProgramsName`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postProgramBatchSpecialization = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createProgramBatchSpecialization`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getFacilityBookedSlots = async ({
  facilityBookingId = '',
  facilityId = '',
  academicPlannerActivityId = '',
}) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacilityBookingData?facilityBookingId=${facilityBookingId}&facilityId=${facilityId}&academicPlannerActivityId=${academicPlannerActivityId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getFacultyBookingsData = async ({
  facultyBookingId = '',
  facultyId = '',
  academicPlannerActivityId = '',
}) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacultyBookingsData?facultyBookingId=${facultyBookingId}&facultyId=${facultyId}&academicPlannerActivityId=${academicPlannerActivityId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getAcademicPlannerSession = async (termId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/AcademicPlannerData/?term=${termId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getSessionData = async ({ term = '', facilityId = '', facultyId = '' }) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SessionData/?termId=${term}&facilityId=${facilityId}&facultyId=${facultyId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const sessionCUD = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/createSession`
  );
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
}

export const getBookedSlotById = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacilityBookingData/?facilityBookingId=${id}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getBookedSlotDelete = async (deleteData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createFacilityFacultyBooking`
  );
  const res = await axiosInstance.post(`${path}${query}`, deleteData);
  return res && res.data ? res.data : null;
};

export const createBookedSlot = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createFacilityFacultyBooking`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const getFaciltyAvailableData = async (startDate, endDate) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacilityFacultyAvailableData/?startDate=${startDate}&endDate=${endDate}`
  );
  console.log('datecheck===', startDate, endDate);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getAllFacultyFacilitySubject = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacilityFacultyBookingData/?academicPlannerActivityId=${id}`
  );

  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// /services/apexrest/FacilityFacultyBookingData/?academicPlannerActivityId=a2R6D000000leF2UAI

export const getTermData = async (filter) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  // services/apexrest/CurrentPageFilter/?intake=JAN&program=Global+MBA&year=2023

  const query = encodeURIComponent(
    `services/apexrest/CurrentPageFilter/?intake=${filter.intake}&program=${filter.program}&batch=${filter.year}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getCourseVersion = async (term) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  // services/apexrest/CurrentPageFilter/?intake=JAN&program=Global+MBA&year=2023

  const query = encodeURIComponent(
    `services/apexrest/CourseVersionData/?term=${term}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getReferenceApi = async (term) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  // services/apexrest/CurrentPageFilter/?intake=JAN&program=Global+MBA&year=2023

  const query = encodeURIComponent(
    `/services/apexrest/ActivitiesData/?programName=&intake=&year=&campus=&term=${term}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const addEventForBook = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/CreateActivities`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const updateReferenceActivities = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/createActivities`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getFacultyAndFacilty = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/FacilityFacultyAllData`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getAcademicPlannerData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/AcademicPlannerData/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postAcademicPlanner = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createAcademicPlannerActivity`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getCourseVersionData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/CourseVersionData/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
// export const postAcademicPlanner = async (data) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(
//     `services/apexrest/createAcademicPlannerActivity`
//   );
//   const res = await axiosInstance.post(`${path}${query}`, data);
//   return res && res.data ? res.data : null;
// };
// export const getCourseVersionData = async (data) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(
//     `services/apexrest/CourseVersionData/${data}`
export const postCourseVersionData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/createCourseVersion`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const getMasterActivityWithTermData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/MasterActivityWithTermData/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getImportTermActivity = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/importTermActivity/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// ------------------------------------------- Exam Module ------------------------------------------------------//

export const getExamData = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/ExamData/?dueDays=${filterData.duedays}`
  );
  const res = await axiosInstance.get(`${path}${query}`);

  return res && res.data ? res.data : null;
};

export const getStudentRiskDataData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/StudentRiskData`);
  const res = await axiosInstance.get(`${path}${query}`);

  return res && res.data ? res.data : null;
};

export const getStudentStatusData = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/StudentData/?filter=${filterData.filter}&campus=${filterData.campus}&course=${filterData.course}&eligibilityStatus=${filterData.eligibilityStatus}&reason=${filterData.reason}`
  );
  const res = await axiosInstance.get(`${path}${query}`);

  return res && res.data ? res.data : null;
};

export const postStudentStatusData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/StudentData`);
  const res = await axiosInstance.post(`${path}${query}`, data);

  return res && res.data ? res.data : null;
};

export const getQuestionPaperData = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/QuestionPaper?course=${filterData.course}&status=${filterData.status}&term=${filterData.term}&faculty=${filterData.faculty}`
  );
  const res = await axiosInstance.get(`${path}${query}`);

  return res && res.data ? res.data : null;
};

export const postQuestionPaperData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/QuestionPaper`);
  const res = await axiosInstance.post(`${path}${query}`, data);

  return res && res.data ? res.data : null;
};

export const getSeatingPlanData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/TimeTable`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getEvaluationDetailsData = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/EvaluationDetails?course=${filterData.course}&deadline=${filterData.deadline}&dateOfExam=${filterData.dateOfExam}&subjectFaculty=${filterData.subjectFaculty}&allocatedTo=${filterData.allocatedTo}&status=${filterData.status}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postEvaluationDetailsData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/EvaluationDetails`);
  const res = await axiosInstance.post(`${path}${query}`, data);

  return res && res.data ? res.data : null;
};

export const getInvigilator_s1_Data = async (filter) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/TimeTable?course=${filter.course}&date=${filter.date}&duration=${filter.duration}&examType=${filter.examType}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getInvigilator_s1_Datas = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/TimeTable?course`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postInvigilator_s1_Data = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/TimeTable`);
  const res = await axiosInstance.post(`${path}${query}`, data);

  return res && res.data ? res.data : null;
};

export const getInvigilator_s2_Data = async (filter) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/InvigilatorDetails?examId=${filter.id}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// export const postInvigilator_s2_Data = async (data) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(`/services/apexrest/InvigilatorDetails`);
//   const res = await axiosInstance.post(`${path}${query}`, data);

//   return res && res.data ? res.data : null;
// };

export const getMasterSubjectsWithTermData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/MasterSubjectsWithTermData/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getImportTermwiseSubjectData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/importTermSubjects/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postSeatingPlanData = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/TimeTable`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};
export const getSeatingArrangement = async (examId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SeatingDetails?examId=${examId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getFacilityData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/FacilityData`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postFacilityData = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/FacilityData`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};

export const getRetestData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/RetestRevaluationDetails`
  );
  const res = await axiosInstance.get(`${path}${query}?type=Retest`);
  return res && res.data ? res.data : null;
};

export const getRevalData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/RetestRevaluationDetails`
  );
  const res = await axiosInstance.get(`${path}${query}?type=Revaluation`);
  return res && res.data ? res.data : null;
};

export const postRetestData = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/RetestRevaluationDetails`
  );
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};

export const postInvigilator_s2_Data = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=/services/apexrest/InvigilatorDetails`;
  // const query = encodeURIComponent(`/services/apexrest/InvigilatorDetails`);
  const res = await axiosInstance.post(`${path}`, payload);
  return res && res.data ? res.data : null;
};
export const getFacilityBookingDetails = async (examId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacilityBookingDetails?examId=${examId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postSeatingArrangement = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/SeatingDetails`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};
export const getStudentExamRoom = async (examId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/StudentExamRoom?examId=${examId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getpdfdata = async (examId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/QuestionPaperForExam?questionPaperId=a136D0000054x3uQAA`
  );
  const res = await axiosInstance.get(`${path}${query}`, {
    // responseType: 'blob',
    // contentType: 'application/pdf',
  });

  console.log('resresresresresresres', res);
  return res && res.data ? res.data : null;
};
export const getSectionOfferingData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/CourseOfferingData/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postSectionOfferingData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/createCourseOffering`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
// grading api
export const getGradingCourseDetails = async (examId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/GradingCourseDetails`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getGradingDetails = async (gradingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/GradingDetails?gradingId=${gradingId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// Enrollment - Student
export const getDataForTermEnrolment = async (instituteId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/getDataForTermEnrolment?instituteId=${instituteId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getStudentDataForTermEnrolment = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/getStudentDataForTermEnrolment?academicProgramId=${payload.academicProgramId}&instituteId=${payload.instituteId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getDataForCourseEnrolment = async (instituteId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/getDataForCourseEnrolment?&instituteId=${instituteId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getStudentAndCourseForEnrolment = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/getStudentAndCourseForEnrolment?academicProgramId=${payload.academicProgramId}&instituteId=${payload.instituteId}&sectionName=${payload.sectionName}&termId=${payload.termId}&specializationId=${payload.specializationId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postEnrolmentTillCourses = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createEnrolmentTillCourses`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getAcademicCalendar = async (termId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = `/services/apexrest/AcademicCalendar?${termId}`;
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postAcademicCalendar = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=/services/apexrest/AcademicCalendar/`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const postValidateSession = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/validateSession`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const postCreateSession = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/createSession`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getCourseOfferingByCourseAndTerm = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/CourseOfferingByCourseAndTerm?CourseId=${payload.CourseId}&TermId=${payload.TermId}`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getFacultyList = async (querry) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/FacultyList/${querry}`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};